import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter-panel-header" }
const _hoisted_2 = { class: "filter-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "filter-search" }
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = { class: "filter-options" }
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "filter-option-label" }

import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import type { FilterOption, FilterTab } from "./type";

type IsFilterSelected = (id: string) => boolean;


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanningFilters',
  props: {
    activeFilterTab: {},
    filterSearch: {},
    filterTabs: {},
    filteredFilterOptions: {},
    hasActiveFilters: { type: Boolean },
    isFilterSelected: { type: Function }
  },
  emits: ["update:activeFilterTab", "update:filterSearch", "toggle-filter", "clear-all-filters", "close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const filterPanelRef = ref<HTMLElement | null>(null);

// Close the panel when clicking outside
onClickOutside(filterPanelRef, () => {
  emit("close");
});

const handleSearchInput = (event: Event) => {
  emit("update:filterSearch", (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "filterPanelRef",
    ref: filterPanelRef,
    class: "filter-panel"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "filter-panel-title" }, "Filters", -1)),
      (__props.hasActiveFilters)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "clear-filters-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear-all-filters')))
          }, " Clear all "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filterTabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.key,
          class: _normalizeClass(["filter-tab", { 'filter-tab--active': __props.activeFilterTab === tab.key }]),
          onClick: ($event: any) => (_ctx.$emit('update:activeFilterTab', tab.key))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        type: "text",
        value: __props.filterSearch,
        placeholder: 'Search ' + __props.activeFilterTab + '...',
        class: "filter-search-input",
        onInput: handleSearchInput
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filteredFilterOptions, (option) => {
        return (_openBlock(), _createElementBlock("label", {
          key: option.id,
          class: "filter-option"
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: __props.isFilterSelected(option.id),
            class: "filter-checkbox",
            onChange: ($event: any) => (_ctx.$emit('toggle-filter', option.id))
          }, null, 40, _hoisted_7),
          _createElementVNode("span", _hoisted_8, _toDisplayString(option.name), 1)
        ]))
      }), 128))
    ])
  ], 512))
}
}

})